'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	BILLING_TRIAL:
		'You will not be charged for $trialDays days. You will then be charged $price a month. You can cancel at any time. PayPal will email you an authorisation which is not a charge.',
	BILLING: 'You will be charged $price $period. You can cancel your subscription at any time.',
	BILLING_WITH_COUPON:
		'You will be charged $price $couponDuration. You can cancel your subscription at any time.',
	BILLING_TRIAL_COUPON:
		'You will not be charged for $trialDays days. You will then be charged $price $couponDuration. You can cancel at any time. PayPal will email you an authorisation which is not a charge.',
	BILLING_ONE_OFF: 'You will be charged $[price].',
	BILLING_COUPON: '$monthLang, and $fullPrice a month thereafter',
	BILLING_DETAILS_UPDATED:
		'Your billing agreement with us is unchanged. Your account details will be updated.',
	BILLING_PERIOD_ONE: 'per $interval',
	BILLING_PERIOD_MULTIPLE: 'every $intervalCount $[interval]s',
	BILLING_CHANGE: 'Change your billing details'
});
